import React, { useEffect, useState } from 'react';
import useSWR from 'swr';
import { Form, Button, Card, Alert, Spinner } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { medicoAgenda } from '../../../helpers/agenda/medicos';
import { formatarHorario } from '../../../util/utils';
import api from '../../../services/api';

const medicoMap = {
  'JOAO C. MORON SAES BRAGA': 'Dr João',
  ESTUDOS: 'Estudo',
  'ALEXANDRE RODRIGUES': 'Dr Alexandre',
  'CASSIA SPINOLA CUSTODIO RODRIGUES': 'Drª Cassia',
  'ECG EXTERN': 'EcgExt',
  'ECO INTERNADO': 'EcoInt',
  'FABIO VILLAÇA GUIMARÃES FILHO': 'Dr Fabio',
  'FERNANDA DI TULLIO T. VILELA': 'Drª Fernanda',
  'IGOR RIBEIRO DE CASTRO BIENERT': 'Dr Igor',
  'LUIZ GUSTAVO VARGAS BATISTA DO NASCIMENTO': 'Dr Luiz',
  'MARINA MONTEBELLO PIEDADE': 'Drª Marina',
  'METODO GRAFICO': 'MG',
  'RAPHAEL APARECIDO BARRETO DA SILVA': 'Dr Raphael',
  'ROBERTO DAHER': 'Dr Roberto',
  'VALDYR DATILO': 'Dr Valdyr',
};

const formatarData = data => new Date(data).toLocaleDateString('pt-BR');

const montarRelatorioPorMedicoHTML = (agendas, dataAgenda) => {
  const relatorioPorMedico =
    agendas?.reduce((acc, agendamento) => {
      const nomeMedico = agendamento.NOMEMED;
      if (!acc[nomeMedico]) acc[nomeMedico] = [];
      acc[nomeMedico].push(agendamento);
      return acc;
    }, {}) ?? {};

  return Object.entries(relatorioPorMedico)
    .map(([medico, agendamentos]) => {
      const rows = agendamentos
        .map(
          a =>
            `<tr><td>${formatarHorario(a.HORARIO)}</td><td>${a.NOMEPAC}</td><td>${a.DESCPROCEDI}</td><td>${a.SIGLACONV}</td><td>${a.CELULARPAC}</td><td></td></tr>`
        )
        .join('');

      return `<br></br><h4>Médico: ${medico} - ${formatarData(
        dataAgenda
      )}</h4><table border="1" style="width: 100%; border-collapse: collapse;font-size: 0.8em;"><tr><th style="width: 5%;">Horário</th><th style="width: 30%;">Paciente</th><th style="width: 20%;">Procedimento</th><th style="width: 15%;">Convênio</th><th style="width: 12%;">Celular</th><th style="width: 18%;">Anotação</th></tr>${rows}</table>`;
    })
    .join('');
};

export default function FormAgendaDiaria() {
  const [selectedMedico, setSelectedMedico] = useState([]);
  const location = useLocation();
  const data = location?.state?.data;
  const { data: agendadiaria, isLoading, error } = useSWR(
    data ? `agenda/diaria?dataagenda=${data}` : null,
    url => api.get(url).then(res => res.data),
    { revalidateOnFocus: false }
  );

  const handleSelectMedico = ({ medico }) => {
    setSelectedMedico(prev =>
      prev.includes(medico) ? prev.filter(m => m !== medico) : [...prev, medico]
    );
  };

  const filterAgendas = agendadiaria?.filter(
    a => !selectedMedico.length || selectedMedico.includes(medicoMap[a.NOMEMED])
  );

  useEffect(() => {
    const elemFechamento = document.getElementById('fechamento');
    if (!elemFechamento) return;

    elemFechamento.innerHTML = montarRelatorioPorMedicoHTML(
      filterAgendas,
      agendadiaria?.[0]?.DATAAGENDA
    );
  }, [filterAgendas, agendadiaria]);

  if (error) {
    return (
      <Alert variant="danger" role="alert" aria-live="assertive">
        Falha ao carregar agenda diária. Tente novamente.
      </Alert>
    );
  }

  if (isLoading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: 160 }}
      >
        <Spinner
          animation="border"
          role="status"
          aria-live="polite"
          aria-label="Carregando"
        />
      </div>
    );
  }

  return (
    <Card id="cardHeader" style={{ marginTop: 10 }}>
      <Card.Header className="text-center font-weight-bold">
        AGENDA DIÁRIA
      </Card.Header>

      <div className="d-flex justify-content-center mt-2" style={{ gap: 5 }}>
        <Button onClick={() => window.print()}>Imprimir</Button>
        <Button variant="warning" onClick={() => setSelectedMedico([])}>
          Limpar Filtros
        </Button>
      </div>

      <div className="mt-2 text-center">
        {medicoAgenda.map(agenda => (
          <Form.Check
            id={agenda.codigo}
            key={agenda.codigo}
            inline
            checked={selectedMedico.includes(agenda.medico)}
            type="checkbox"
            label={agenda.medico}
            onChange={() => handleSelectMedico(agenda)}
          />
        ))}
      </div>
      <div style={{ marginBottom: 5 }} id="fechamento" />
    </Card>
  );
}
